import { SpeechService } from '@/features/speech/data/speech.service.ts'
import type { Speech } from '@/features/speech/domain/models/speech.ts'
import type { Voice } from '@/features/voice/domain/models/voice.ts'
import { storeSpeech } from '@/features/speech/domain/use-cases/store-speech.ts'
import { scriptSelector, useScriptStore } from '@/shared/store/script.store.ts'

export const createTTSSpeech = async (
  scriptId: string,
  voice: Voice,
  speed = 1,
  expressive = false,
  scriptTextOverride?: string
): Promise<Speech> => {
  const scriptText =
    scriptTextOverride ??
    scriptSelector(scriptId)(useScriptStore.getState())?.text

  if (!scriptText) {
    throw new Error(`Script not found for TTS generation: ${scriptId}`)
  }

  const speech = await SpeechService.createSpeech(
    scriptText,
    voice.id,
    speed,
    expressive
  )
  storeSpeech(speech, scriptId, voice, speed, expressive)
  return speech
}
